// Generated by purs version 0.15.0
var lift = function (dict) {
    return dict.lift;
};
export {
    lift
};
//# sourceMappingURL=index.js.map
